// extracted by mini-css-extract-plugin
module.exports = {"container":"HW","noResults":"IW","contact":"JW"};